<template>
  <div class="module-wrapper">
    <div class="module-header animated fadeInDown">
      <h2>Tasks</h2>
      <button @click="addTask" class="btn btn-gradient-task">
        <i class="fas fa-plus"></i> Add Task
      </button>
    </div>

    <div v-if="loading" class="spinner-container">
      <i class="fas fa-spinner fa-spin fa-2x"></i> Loading Tasks...
    </div>

    <div v-else>
      <table v-if="tasks.length" class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Task</th>
            <th>Assigned To</th>
            <th>Deadline</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="task in tasks" :key="task.id">
            <td>{{ task.title }}</td>
            <td>{{ task.assignee }}</td>
            <td>{{ task.deadline }}</td>
            <td>
              <span :class="['badge', task.status==='completed'?'active':'inactive']">{{ task.status }}</span>
            </td>
            <td>
              <button @click="editTask(task)" class="btn btn-sm btn-primary">Edit</button>
              <button @click="deleteTask(task.id)" class="btn btn-sm btn-danger">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-else>No tasks found.</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'TasksComponent',
  computed: { ...mapState('tasks', ['tasks','loading']) },
  methods: {
    addTask(){ this.$router.push({name:'AddTask'}); },
    editTask(task){ console.log('Edit', task); },
    deleteTask(id){ if(confirm('Delete this task?')) this.$store.dispatch('tasks/deleteTask', id); }
  },
  mounted(){ this.$store.dispatch('tasks/fetchTasks'); }
};
</script>

<style scoped>
.btn-gradient-task { background: linear-gradient(135deg,#f7971e,#ffd200); color:#fff; border:none; padding:8px 15px; border-radius:6px; transition:all 0.3s;}
.btn-gradient-task:hover{ transform: scale(1.05);}
</style>
